var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "左间距(cm)" } },
        [
          _c("el-input-number", {
            staticClass: "setting-style_height",
            attrs: {
              "controls-position": "right",
              placeholder: "请输入左间距",
              precision: _vm.precision,
              step: _vm.step,
              min: 0,
              max: 40
            },
            model: {
              value: _vm.paddingLeft,
              callback: function($$v) {
                _vm.paddingLeft = _vm._n($$v)
              },
              expression: "paddingLeft"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0bbefaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0bbefaa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/style_setting/SettingStylePaddingleft.vue
// module id = null
// module chunks = 